import track from '../lib/event';
import config from '../config';

const { eventTrack } = config;

export default {
  inserted: (el, binding, vnode) => {
    if (binding.value.vmodel) return;
    if (!Object.prototype.hasOwnProperty.call(eventTrack, 'enable') || !eventTrack.enable) return;
    el.addEventListener('click', () => {
      const fn = () => {
        setTimeout(() => {
          track.event(binding.value, vnode);
        }, 100);
      };
      fn.apply(vnode.context);
    });
  },
  // eslint-disable-next-line
  update: (el, binding, vnode) => {
    if (!Object.prototype.hasOwnProperty.call(eventTrack, 'enable') || !eventTrack.enable) return;
    if (!binding.value.vmodel) return;
    if (JSON.stringify(binding.oldValue) !== JSON.stringify(binding.value)) {
      track.event(binding.value);
    }
  },
};
